import { TachoReleaseTypeEnum } from 'tacho-models';

export enum TachoReleaseType {
    FullInstaller = 'FullInstaller',
    Updater = 'Updater',
    UpdaterAsZip = 'UpdaterAsZip',
    ManagerPackage = 'ManagerPackage',
}

export const managerPackageApiValue = 4 as TachoReleaseTypeEnum;

export const tachoReleaseTypeEnumTranslationsPl = {
    FullInstaller: 'Instalator',
    Updater: 'Aktualizacja',
    UpdaterAsZip: 'Aktualizacja spakowana (zip)',
    ManagerPackage: 'Paczka Managera (komponenty)',
};

export const tachoReleaseTypeEnumTranslationsEn = {
    FullInstaller: 'FullInstaller',
    Updater: 'Updater',
    UpdaterAsZip: 'Updater as zip',
    ManagerPackage: 'Manager package (components)',
};

export const mapTachoReleaseTypeToApiModel = (internalModel: TachoReleaseType): TachoReleaseTypeEnum => {
    switch (internalModel) {
        case TachoReleaseType.FullInstaller:
            return TachoReleaseTypeEnum.FullInstaller;
        case TachoReleaseType.Updater:
            return TachoReleaseTypeEnum.Updater;
        case TachoReleaseType.UpdaterAsZip:
            return TachoReleaseTypeEnum.UpdaterAsZip;
        case TachoReleaseType.ManagerPackage:
            return managerPackageApiValue;
    }
};

export const mapApiModelToTachoReleaseType = (apiModel: TachoReleaseTypeEnum): TachoReleaseType => {
    if (apiModel === managerPackageApiValue) {
        return TachoReleaseType.ManagerPackage;
    }

    switch (apiModel) {
        case TachoReleaseTypeEnum.FullInstaller:
            return TachoReleaseType.FullInstaller;
        case TachoReleaseTypeEnum.Updater:
            return TachoReleaseType.Updater;
        case TachoReleaseTypeEnum.UpdaterAsZip:
            return TachoReleaseType.UpdaterAsZip;
    }
};
